/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Advanced_OptionsInputs */

const en_offline_sync_advanced_options = /** @type {(inputs: Offline_Sync_Advanced_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advanced Options`)
};

const fr_offline_sync_advanced_options = /** @type {(inputs: Offline_Sync_Advanced_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options avancées`)
};

const de_offline_sync_advanced_options = /** @type {(inputs: Offline_Sync_Advanced_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erweiterte Optionen`)
};

const it_offline_sync_advanced_options = /** @type {(inputs: Offline_Sync_Advanced_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni avanzate`)
};

const ru_offline_sync_advanced_options = /** @type {(inputs: Offline_Sync_Advanced_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дополнительные параметры`)
};

const es_offline_sync_advanced_options = /** @type {(inputs: Offline_Sync_Advanced_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones avanzadas`)
};

const zh_cn2_offline_sync_advanced_options = /** @type {(inputs: Offline_Sync_Advanced_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高级选项`)
};

const ja_offline_sync_advanced_options = /** @type {(inputs: Offline_Sync_Advanced_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`詳細オプション`)
};

const hi_offline_sync_advanced_options = /** @type {(inputs: Offline_Sync_Advanced_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उन्नत विकल्प`)
};

const pt_pt2_offline_sync_advanced_options = /** @type {(inputs: Offline_Sync_Advanced_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções avançadas`)
};

/**
* | output |
* | --- |
* | "Advanced Options" |
*
* @param {Offline_Sync_Advanced_OptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_advanced_options = /** @type {((inputs?: Offline_Sync_Advanced_OptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Advanced_OptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_sync_advanced_options(inputs)
	if (locale === "de") return de_offline_sync_advanced_options(inputs)
	if (locale === "it") return it_offline_sync_advanced_options(inputs)
	if (locale === "ru") return ru_offline_sync_advanced_options(inputs)
	if (locale === "es") return es_offline_sync_advanced_options(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_sync_advanced_options(inputs)
	if (locale === "ja") return ja_offline_sync_advanced_options(inputs)
	if (locale === "hi") return hi_offline_sync_advanced_options(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_sync_advanced_options(inputs)
	return en_offline_sync_advanced_options(inputs)
});